var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "retFinalPayModal",
      staticClass: "retention-final-confirm-modal",
      attrs: {
        hasCancelBtn: false,
        okBtnAction: "ok",
        beforeOkClick: _vm.handleBeforeDecisionOk,
      },
    },
    [
      _c("FinalPaymentModalTemplate"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "final-payment-decisions" },
        _vm._l(_vm.decisions, function (decision) {
          return _c(
            "HKLRadioButton",
            {
              key: decision.value,
              staticClass: "final-payment-decisions__option",
              attrs: { value: decision.value },
              model: {
                value: _vm.selectedDecision,
                callback: function ($$v) {
                  _vm.selectedDecision = $$v
                },
                expression: "selectedDecision",
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t(decision.label)) + "\n    ")]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }